// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_15Vyi8-2ZdIsRnxXojT0g9"};